module.exports = __webpack_public_path__ + "static/media/CA28BF57.c1b495a6.png";